"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Organization = exports.isOrganization = void 0;
const PropertyMapper_1 = require("./PropertyMapper");
function isOrganization(organization) {
    return organization instanceof Organization;
}
exports.isOrganization = isOrganization;
class Organization {
    constructor(id, name) {
        this.validators = [];
        this.subQuorumAvailable = false;
        this.has30DayStats = false;
        this.has24HourStats = false;
        this.subQuorum24HoursAvailability = 0;
        this.subQuorum30DaysAvailability = 0;
        this.unknown = false;
        this.id = id;
        this.name = name;
    }
    get subQuorumBlockedAt() {
        return this.validators.length - this.subQuorumThreshold + 1;
    }
    get subQuorumThreshold() {
        return Math.floor(this.validators.length - (this.validators.length - 1) / 2); //simple majority
    }
    get isTierOneOrganization() {
        if (!this.has30DayStats)
            return false;
        return this.subQuorum30DaysAvailability >= 99 && this.validators.length >= 3;
    }
    toJSON() {
        return {
            id: this.id,
            name: this.name,
            dba: this.dba,
            url: this.url,
            horizonUrl: this.horizonUrl,
            logo: this.logo,
            description: this.description,
            physicalAddress: this.physicalAddress,
            physicalAddressAttestation: this.physicalAddressAttestation,
            phoneNumber: this.phoneNumber,
            phoneNumberAttestation: this.phoneNumberAttestation,
            keybase: this.keybase,
            twitter: this.twitter,
            github: this.github,
            officialEmail: this.officialEmail,
            validators: this.validators,
            subQuorumAvailable: this.subQuorumAvailable,
            subQuorum24HoursAvailability: this.subQuorum24HoursAvailability,
            subQuorum30DaysAvailability: this.subQuorum30DaysAvailability,
            has30DayStats: this.has30DayStats,
            has24HourStats: this.has24HourStats,
            dateDiscovered: this.dateDiscovered,
            isTierOneOrganization: this.isTierOneOrganization
        };
    }
    static fromJSON(organizationJSON) {
        let organizationDTO;
        if (typeof organizationJSON === 'string') {
            organizationDTO = JSON.parse(organizationJSON);
        }
        else
            organizationDTO = organizationJSON;
        if (!organizationDTO.id) {
            throw new Error("organizationDTO missing id");
        }
        let organization = new Organization(organizationDTO.id, organizationDTO.name);
        PropertyMapper_1.default.mapProperties(organizationDTO, organization, ['id', 'name', 'dateDiscovered', 'dateUpdated', 'isTierOneOrganization']);
        if (organizationDTO.dateDiscovered !== undefined)
            organization.dateDiscovered = new Date(organizationDTO.dateDiscovered);
        return organization;
    }
    toString() {
        return `Organization (id: ${this.id}, name: ${this.name})`;
    }
}
exports.Organization = Organization;
//# sourceMappingURL=organization.js.map